import styled from "@emotion/styled";
import * as React from "react";

import { Icon, IconsEnum } from "components/icon";

interface IProps {
  isVisible: boolean;
  size?: string;
}

interface IWrapperProps {
  isVisible: boolean;
}

const Wrapper = styled.div<IWrapperProps>`
  visibility: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isVisible ? "visible" : "hidden")
  };
  opacity: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.isVisible ? 1 : 0)
  };
  transition: all 0.2s ease-in-out;
  display: inline-block;
`;

const StyledIcon = styled(Icon)`
  animation: rotate 1s cubic-bezier(0.17, 0.67, 0.83, 0.67) infinite;

  @keyframes rotate {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const LoadingSpinner: React.FC<IProps> = ({ size, isVisible }) => (
  <Wrapper isVisible={isVisible}>
    <StyledIcon name={IconsEnum.Spinner} width={size} height={size} inline />
  </Wrapper>
);
